export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
export const PRIMARY_COLOR = '#00B569';

export const PAGE_SIZE_OPTIONS = {
  5: '5',
  10: '10',
  15: '15',
  20: '20',
  25: '25',
  30: '30',
  50: '50',
  100: '100',
} as const;

export const DATE_FORMATS = { DATE: 'DD/MM/YYYY', DATETIME: 'DD/MM/YYYY HH:mm' } as const;
